export default __webpack_public_path__ + "static/snapshot-a53dd804555c8c5844b768db21764740.gif";